import {
  CustomButton,
  CustomInputSelect,
  CustomTextInput,
} from '@Modules/core/components';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import CustomReactSelect, { SelectOption } from '@Modules/core/components/form/CustomReactSelect';
import CustomAppModal from '@Modules/core/components/modal/CustomModal';
import CustomReactTable from '@Modules/core/components/table/CustomReactTable';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import TraderSelectOption from '@Shared/components/form/TraderSelectOption';
import React from 'react';

const UsersSelectMeta: FormInputMeta = {
  name: 'usersSelect',
  type: 'select',
  options: [
    {
      label: 'Bill',
      value: 'bill',
    },
    {
      label: 'Zuck',
      value: 'zuck',
    },
    {
      label: 'Marc',
      value: 'marc',
    },
  ],
};

const fromTextInputMeta: FormInputMeta = {
  name: 'from',
  type: 'date',
};

const data: any[] = [{}, {}, {}, {}, {}, {}, {}, {}];

const columns = [
  {
    accessorKey: 'accessorkey',
    id: 'id',
    header: 'Date Ope.',
    cell: '12/12/2023',
  },
  {
    accessorKey: 'accessorkey2',
    id: 'id2',
    header: 'Trigger',
    cell: '805289143-4',
  },
  {
    accessorKey: 'accessorkey2',
    id: 'id3',
    header: 'Id Val.',
    cell: '89143-4',
  },
  {
    accessorKey: 'accessorkey2',
    id: 'id4',
    header: 'Champ',
    cell: '89143-489143-489',
  },
  {
    accessorKey: 'accessorkey2',
    id: 'id5',
    header: 'Champ.Desc',
    cell: 'Radios are used when only one choice may',
  },
  {
    accessorKey: 'accessorkey2',
    id: 'id6',
    header: 'Encien.val',
    cell: '3-489',
  },
  {
    accessorKey: 'accessorkey2',
    id: 'id7',
    header: '9-489',
    cell: '11:14',
  },
  {
    accessorKey: 'accessorkey2',
    id: 'id8',
    header: 'Utilisateur',
    cell: 'Micke',
  },
  // {
  //   accessorKey: 'accessorkey3',
  //   id: 'id9',
  //   header: 'Action',
  //   cell: () => (
  //     <CC.Box>
  //       <CustomButton>Edit</CustomButton>
  //       <CustomButton variant="ghost" ml="2">
  //         Delete
  //       </CustomButton>
  //     </CC.Box>
  //   ),
  // },
];

const traderOptions: readonly SelectOption[] = [
  {
    label: 'Mark Zuckerberg',
    value: 'marc-zuck',
  },
  {
    label: 'Christophe Colombe',
    value: 'christophe-colombe',
  },
];

export default function SensibleDataLog() {
  const SelectUsersModalRef = React.useRef<{ onOpen: () => void }>();
  // const bgColor = CC.useColorModeValue('gray.100', 'gray.600');

  return (
    <>
      <CC.Box>
      <CC.Stack px="4">
          <CC.Flex w="full" flexDirection={{base: 'column', md: 'row'}} justify="space-between" alignItems={{ base: 'flex-start', md: 'center'}}>
            <CC.Box w="full" maxW="md" pr={{ base: 0, md: 4}}>
            <CC.FormControl>
                <CC.FormLabel htmlFor={'trader'} fontWeight={'normal'}>
                  Utilisteurs
                </CC.FormLabel>
                    <CustomReactSelect
                      w='full'
                      isLoading={false}
                      closeMenuOnSelect={true}
                      components={{ Option: TraderSelectOption }}
                      options={traderOptions}
                    />
              </CC.FormControl>
            </CC.Box>

            <CC.Box w='full' mt={{ base: 2, md: 0}}>
              <CC.Text>De:</CC.Text>
              <CustomTextInput meta={fromTextInputMeta} />
            </CC.Box>

            <CC.Box w='full' ml={{ base: 0, md: 2}} mt={{ base: 2, md: 0}}>
              <CC.Text>à:</CC.Text>
              <CustomTextInput meta={fromTextInputMeta} />
            </CC.Box>
          </CC.Flex>
          <CC.Flex justify="flex-end" alignItems="center">
            <CustomButton>Afficher les Logs</CustomButton>
          </CC.Flex>
        </CC.Stack>


        <CC.Box mt="4">
          <CustomReactTable data={data} columns={columns} />
        </CC.Box>
      </CC.Box>

      <CustomAppModal
        title="Selectionner l'utilisateur"
        actionBtnText="Selectionner"
        ref={SelectUsersModalRef}
        size="3xl"
      >
        <CC.Box minH="72">
          <CC.Text color="gray.500" mb="4">
            Selectionner l'utilisateur dont vous souhaitez voir les logs
          </CC.Text>

          <CC.Box>
            <CustomFormControl label='Nom de l"utilisateur'>
              <CustomTextInput
                meta={{
                  name: 'name',
                  type: 'text',
                  placeholder: "Nom de l'utilisateur",
                }}
              />
            </CustomFormControl>
            <CustomInputSelect my="4" meta={UsersSelectMeta} />
            <CustomButton>Rechercher</CustomButton>
          </CC.Box>
        </CC.Box>
      </CustomAppModal>
    </>
  );
}
